<div class="halls">
  <h2>祠堂管理</h2>
  <p class="halls-desc">
    对接接口 <code>/ancestral/halls</code>；查询参数 <code>keyword</code>，分页 <code>page</code>、<code>page_size</code>。
  </p>

  <div v-if="errorMsg" class="error-banner">{{ errorMsg }}</div>

  <div class="search-bar">
    <input
      v-model="keyword"
      type="search"
      class="search-input"
      placeholder="关键词搜索（祠堂名称、姓氏等）"
      autocomplete="off"
      @input="handleSearchInput"
      @keyup.enter="handleSearch"
    />
    <button type="button" class="search-btn" :disabled="loading" @click="handleSearch">
      查询
    </button>
  </div>

  <div class="halls-layout">
    <div class="table-container">
      <div v-if="loading" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>

      <div class="table-scroll">
        <table v-if="!loading" class="data-table">
          <thead>
            <tr>
              <th class="th-cover">封面</th>
              <th>ID</th>
              <th>祠堂名称</th>
              <th>别称</th>
              <th>姓氏</th>
              <th>始祖</th>
              <th>起源地</th>
              <th>简介</th>
              <th>族谱数据</th>
              <th>定制</th>
              <th>个人族谱ID</th>
              <th>添加人</th>
              <th class="th-action">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="hallList.length === 0">
              <td colspan="13" class="empty-text">暂无祠堂数据</td>
            </tr>
            <tr
              v-else
              v-for="(item, idx) in hallList"
              :key="pickId(item) + '-' + idx"
              :class="{ 'row-active': selected === item }"
              @click="selectRow(item)"
            >
              <td class="td-cover">
                <img
                  v-if="pickCoverUrl(item)"
                  :src="pickCoverUrl(item)"
                  alt=""
                  class="cover-thumb"
                />
                <span v-else class="cover-placeholder">无</span>
              </td>
              <td>{{ pickId(item) }}</td>
              <td>{{ pickName(item) }}</td>
              <td>{{ pickHallAlias(item) }}</td>
              <td>{{ pickSurname(item) }}</td>
              <td>{{ pickFirstAncestor(item) }}</td>
              <td>{{ pickOriginLocation(item) }}</td>
              <td class="cell-desc">{{ pickIntroShort(item) }}</td>
              <td class="cell-genealogy">{{ pickGenealogySummary(item) }}</td>
              <td>{{ pickIsCustom(item) }}</td>
              <td>{{ pickPersonalGenealogyId(item) }}</td>
              <td>{{ pickAddBy(item) }}</td>
              <td class="td-vr" @click.stop>
                <button
                  type="button"
                  class="vr-link-btn"
                  @click="goToVr(item)"
                >
                  VR
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!loading && hallList.length > 0" class="pagination">
        <button
          type="button"
          :disabled="currentPage <= 1"
          class="page-btn"
          @click="handlePageChange(currentPage - 1)"
        >
          上一页
        </button>
        <span class="page-info">
          第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条
        </span>
        <button
          type="button"
          :disabled="currentPage >= totalPages"
          class="page-btn"
          @click="handlePageChange(currentPage + 1)"
        >
          下一页
        </button>
      </div>

      <button type="button" class="refresh-btn" :disabled="loading" @click="fetchHalls">
        刷新列表
      </button>
    </div>

    <aside class="detail-panel" v-if="selected">
      <h3>详细信息</h3>
      <p class="detail-hint">点击表格一行查看接口返回的完整字段（族谱 JSON 会尝试格式化）。</p>
      <dl class="detail-dl">
        <template v-for="row in detailEntries" :key="row.key">
          <dt>{{ row.key }}</dt>
          <dd><pre class="detail-value">{{ row.value }}</pre></dd>
        </template>
      </dl>
    </aside>
  </div>
</div>
